 
 
// const baseurl = process.env.BASE_URL || 'http://localhost:5001/api/';   
const baseurl = process.env.BASE_URL || 'https://backend.techsparesindia.com/api/';  

// const imageUrl = process.env.IMAGE_URL || 'http://localhost:5001/uploads/';  
const imageUrl = process.env.IMAGE_URL || 'https://backend.techsparesindia.com/uploads/';      

module.exports = { baseurl, imageUrl };
